/**
 * @module ol/events/Key
 */

/**
 * @enum {string}
 * @const
 */
export default {
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown'
};